import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {multipleSelector_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template';
import {filterDropdown_template} from '../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template';

declare var ko: any;

export class merchantsList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;
    protected statusFilter: filterDropdown_template;
    protected categoryFilter: multipleSelector_template;

    public static STATUS_OPTIONS = [
        {id: '', name: 'All'},
        {id: '1', name: 'Active'},
        {id: '0', name: 'Inactive'}
    ];

    protected getTemplateHtml(): string {
        return `
            <div class="sub-header w-justify">
                <div class="w-left">
                    ${this.statusFilter.getHtmlBuild()}
                    ${this.categoryFilter.getHtmlBuild()}
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-categories"></div>
                </div>
            </div>

            <div class="list-header w-justify">
               <div class="w-left"><button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Add Merchant</button></div>
               <div class="w-center">${this.filter.getHtmlBuild()}</div>
               <div class="w-right">${this.pagination.getHtmlBuild()}</div>
            </div>

            <div class="w-list-results" id="list-results">
                <table class="list-results">${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'id') }, css: { 'list-sort-desc': orderByAndDirection()=='id_DESC', 'list-sort-asc': orderByAndDirection()=='id_ASC' }">ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                            <th><span>Special Status</span></th>
                            <th><span>Categories</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isActive') }, css: { 'list-sort-desc': orderByAndDirection()=='isActive_DESC', 'list-sort-asc': orderByAndDirection()=='isActive_ASC' }">Status</span></th>
                            <th><span>Discounts</span></th>
                            <th><span>Delete</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: merchants">
                        <tr class="cursor">
                            <td data-bind="event: { click: $parent.viewMerchant }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: id"></span></a></td>
                            <td data-bind="event: { click: $parent.viewMerchant }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: name"></span></a></td>
                            <td data-bind="event: { click: $parent.viewMerchant }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: specialStatusDisplay"></span></a></td>
                            <td data-bind="event: { click: $parent.viewMerchant }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: categoriesDisplay"></span></a></td>
                            <td data-bind="event: { click: $parent.viewMerchant }"><a class="right-click" data-bind="attr: { href: emakiView }"><span class="status-badge" data-bind="text: isActive ? 'Active' : 'Inactive', css: { 'active': isActive, 'inactive': !isActive }"></span></a></td>
                            <td data-bind="event: { click: $parent.viewMerchant }"><a class="right-click" data-bind="attr: { href: emakiView }"><span data-bind="text: discountCount"></span></a></td>
                            <td>
                                <button class="btn border highlight only-icon icon i-delete" data-bind="event: { click: $parent.onClickDelete }" type="button"></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.statusFilter = new filterDropdown_template("statusFilter", this.getTemplateViewModel(), this.caller);
        this.statusFilter.setLabel('Status');
        this.statusFilter.setOptions(merchantsList_template.STATUS_OPTIONS);

        this.categoryFilter = new multipleSelector_template("categoryFilter", this.getTemplateViewModel(), this.caller);
        this.categoryFilter.setLabel('Categories');
        this.categoryFilter.setFilterContainerClass('margin-neg');
        this.categoryFilter.setTagContainerId('selected-categories');
        this.categoryFilter.setTagContainerCaption('Selected Categories:');
    }

    protected getTemplateName(): string {
        return "merchantsList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): string[] {
        return ["w-content"];
    }

    protected buildViewModel(): any {
        const self = this;
        return {
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("name_ASC"),
            merchants: ko.observableArray([]),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewMerchant: (data, event) => {
                self.viewMerchant(data.id, event);
            },
            onClickDelete: (value, data, event) => {
                self.onClickDelete(value);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd();
            }
        };
    }

    public getViewModelForRequest() {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword,
                status: this.getTemplateViewModel().statusFilter.selectedId,
                categories: this.getTemplateViewModel().categoryFilter.selectedItems
            }
        };
    }

    public onClickReorder(value, data, event) {
        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() === "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }
        data.orderByAndDirection(value + "_" + data.orderByDirection());
        this.caller.filterList();
    }

    public onClickAdd() {
        this.caller.add();
    }

    protected viewMerchant(data, event): any {
        this.caller.viewMerchant(data);
    }

    public onClickDelete(merchant: any): void {
        window.event.stopPropagation();
        const deleteConfirmation: boolean = confirm('Are you sure you want to delete (' + merchant.name + ') merchant? This action cannot be undone.');
        if (deleteConfirmation === true) {
            this.caller.delete(merchant.id);
        }
    }

    public setCategoryOptions(items: any[]): void {
        this.categoryFilter.setItems(items);
    }

    public setListData(merchants: any[]): void {
        const brandId = this.caller.getBrandId();

        merchants.forEach((merchant) => {
            merchant['emakiView'] = '/brand/' + brandId + '/config/merchants/view/' + merchant.id + '/';
            merchant['categoriesDisplay'] = merchant.categories ? merchant.categories.map(c => c.name).join(', ') : '';
            merchant['specialStatusDisplay'] = merchant.specialStatus ? merchant.specialStatus.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase()) : '-';
            merchant['discountCount'] = merchant.discounts ? merchant.discounts.length : 0;
        });

        this.getTemplateViewModel().merchants(merchants);
    }

    public setResultInfo(nbResults, nbPages, execTime): void {
        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public setPageNumber(page: number): void {
        this.pagination.getTemplateViewModel().pageNumber(page);
    }

    public setItemCount(count: number): void {
        this.pagination.getTemplateViewModel().itemCount(count);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/merchantsList_template.ts